import { AddReactionButton } from './AddReactionButton';
import { ReactionsMap, EmojiIcon } from '../utils/reactionsData';
import { observer } from 'mobx-react-lite';
import { ClientItemId } from 'owa-client-ids';
import { ClientItem } from 'owa-mail-store';
import { InstrumentationContext } from 'owa-mail-store';
import * as React from 'react';
import { Callout, DirectionalHint } from '@fluentui/react/lib/Callout';
import { IconButton } from '@fluentui/react/lib/Button';
import Message from 'owa-service/lib/contract/Message';
import { Reaction_AddReaction_Title } from '../utils/reactions.locstring.json';
import getOwnerReactionType from '../utils/getOwnerReactionType';
import loc from 'owa-localize';
import { useToggleState } from 'owa-react-hooks/lib/useToggleState';

const styles = require('./Reactions.scss');

export interface ReactionActionButtonProps {
    conversationId: ClientItemId;
    itemId: ClientItemId;
    item: ClientItem;
    instrumentationContext: InstrumentationContext;
    isConversationView: boolean;
}

export const ReactionActionButton = observer(function ReactionActionButton(
    props: ReactionActionButtonProps
) {
    const divRef = React.useRef<HTMLDivElement>();
    const [isCalloutVisible, toggleIsCalloutVisible, , dismissCallout] = useToggleState(false);

    const getAllReactions = (): JSX.Element[] => {
        const reactions: JSX.Element[] = [];
        const allReactions = Object.keys(ReactionsMap);
        const message: Message = props.item as Message;
        const ownerCurrentReactionType = getOwnerReactionType(message);

        allReactions.forEach(reactionType => {
            reactions.push(
                <AddReactionButton
                    key={reactionType}
                    message={message}
                    conversationId={props.conversationId}
                    itemId={props.itemId}
                    reactionType={reactionType}
                    onAddReactionClicked={dismissCallout}
                    instrumentationContext={props.instrumentationContext}
                    ownerCurrentReactionType={ownerCurrentReactionType}></AddReactionButton>
            );
        });

        return reactions;
    };

    const buttonStyle = props.isConversationView
        ? styles.reactionActionButtonConvView
        : styles.reactionActionButtonItemView;

    return (
        <div ref={divRef}>
            <IconButton
                iconProps={EmojiIcon}
                className={buttonStyle}
                styles={{ icon: styles.addReactionIcon }}
                ariaLabel={loc(Reaction_AddReaction_Title)}
                onClick={toggleIsCalloutVisible}
            />

            <Callout
                target={divRef}
                hidden={!isCalloutVisible}
                isBeakVisible={false}
                gapSpace={1}
                directionalHint={DirectionalHint.topRightEdge}
                onDismiss={toggleIsCalloutVisible}>
                <div className={styles.reactionsCalloutContainer}>{getAllReactions()}</div>
            </Callout>
        </div>
    );
});
